import ApiCaller from 'actions/ApiCaller';
import baseAjaxConfig from 'actions/BaseAjaxConfig';

export const REDEEM_VOUCHER_SUCCESS = 'REDEEM_VOUCHER_SUCCESS';
export const REDEEM_VOUCHER_ERROR = 'REDEEM_VOUCHER_ERROR';
export const REDEEM_VOUCHER_HIDE_ERROR_PAGE = 'REDEEM_VOUCHER_HIDE_ERROR_PAGE';

export function redeemVoucherSuccessAction(data) {
	return { type: REDEEM_VOUCHER_SUCCESS, data };
}

export function redeemVoucherErrorAction(error) {
	return { type: REDEEM_VOUCHER_ERROR, error };
}

export function hideErrorPage() {
	return { type: REDEEM_VOUCHER_HIDE_ERROR_PAGE };
}

export function validateRedeemVoucherCode(code) {
	return dispatch => {
		return ApiCaller.get(
			Object.assign({}, baseAjaxConfig, {
				pathname: `/api/1/coupons/${code}`
			})
		).then(
			data => dispatch(redeemVoucherSuccessAction(data)),
			err => dispatch(redeemVoucherErrorAction(err))
		);
	};
}
